import validate from 'validate.js';
import moment from 'moment';
import * as messages from '../constants/messages';

export const login = {
  email: {
    presence: { message: messages.ERROR_REQUIRED },
    email: { message: messages.ERROR_EMAIL }
  },
  password: {
    presence: { message: messages.ERROR_REQUIRED }
  }
};

export const userType = {
  type: {
    presence: { message: messages.ERROR_REQUIRED }
  }
};

export const user = {
  email: {
    presence: { message: messages.ERROR_REQUIRED },
    email: { message: messages.ERROR_EMAIL }
  },
  firstName: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  lastName: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  ci: {
    presence: { message: messages.ERROR_REQUIRED },
    format: {
      pattern: '[0-9]{7,8}',
      message: messages.INVALID_CI
    }
  },
  phone: {
    presence: { message: messages.ERROR_REQUIRED },
    format: {
      pattern: '[0-9]{8,9}',
      message: messages.INVALID_PHONE
    }
  },
  address: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  password: {
    presence: { message: messages.ERROR_REQUIRED },
    length: {
      minimum: 8,
      tooShort: messages.SHORT_PASSWORD
    }
  },
  passwordConfirmation: {
    presence: { message: messages.ERROR_REQUIRED },
    equality: {
      attribute: 'password',
      message: messages.ERROR_EQUAL_PASS
    }
  }
};

export const director = {
  ...user,
  yearsOfExperience: {
    presence: { message: messages.ERROR_REQUIRED },
    numericality: {
      onlyInteger: true,
      greaterThanOrEqualTo: 0,
      message: messages.INVALID_NUMBER
    }
  },
  graduationDate: {
    presence: { message: messages.ERROR_REQUIRED },
    datetime: {
      dateOnly: true,
      latest: moment.utc(),
      message: messages.ERROR_LESS_DATE
    }
  }
};

export const teacher = {
  ...director
};

export const student = {
  firstName: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  lastName: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  ci: {
    presence: { message: messages.ERROR_REQUIRED },
    format: {
      pattern: '[0-9]{7,8}',
      message: messages.INVALID_CI
    }
  },
  birthdate: {
    presence: { message: messages.ERROR_REQUIRED },
    datetime: {
      dateOnly: true,
      latest: moment.utc(),
      message: messages.ERROR_LESS_DATE
    }
  },
  nationality: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  inscriptionOffice: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  address: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  neighborhood: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  homePhone: {
    presence: { message: messages.ERROR_REQUIRED },
    format: {
      pattern: '[0-9]{8,9}',
      message: messages.INVALID_PHONE
    }
  },
  familyComposition: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  expirationVaccines: {
    datetime: {
      dateOnly: true,
      earliest: moment.utc(),
      message: messages.ERROR_MORE_DATE
    }
  },
  expirationPhysicalAptitude: {
    datetime: {
      dateOnly: true,
      earliest: moment.utc(),
      message: messages.ERROR_MORE_DATE
    }
  },
  category: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  cycleId: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  gradeId: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  otherContact: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  otherContactPhone: {
    presence: { message: messages.ERROR_REQUIRED }
  }
};

export const parentConstraints = {
  ci: {
    presence: { message: messages.ERROR_REQUIRED },
    format: {
      pattern: '[0-9]{7,8}',
      message: messages.INVALID_CI
    }
  },
  relationType: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  firstName: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  lastName: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  email: {
    email: { message: messages.ERROR_EMAIL }
  },
  phone: {
    presence: { message: messages.ERROR_REQUIRED },
    format: {
      pattern: '[0-9]{8,9}',
      message: messages.INVALID_PHONE
    }
  },
  birthdate: {
    presence: { message: messages.ERROR_REQUIRED },
    datetime: {
      dateOnly: true,
      latest: moment.utc(),
      message: messages.ERROR_LESS_DATE
    }
  },
  educationLevel: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  occupation: {
    presence: { message: messages.ERROR_REQUIRED }
  },
  jobPhone: {
    format: {
      pattern: '[0-9]{8,9}',
      message: messages.INVALID_PHONE
    }
  },
};

export const validations = (constraints) => {
  validate.extend(validate.validators.datetime, {
    parse: value => moment.utc(value),
    format: (value, options) => {
      const format = options.dateOnly ? 'YYYY-MM-DD' : 'YYYY-MM-DD hh:mm:ss';
      return moment.utc(value).format(format);
    }
  });
  return data => validate(data.toJS(), constraints, { fullMessages: false }) || {};
};



// WEBPACK FOOTER //
// ./src/utils/constraints.js